<template>
  <div>
    <div class="bd-header bd-header_autovesti2">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__logo" src="/pages/autovesti2/img/logo.png" alt="">
      </div>
    </div>
    <div class="bd-feed bd-feed_autovesti2">
      <div class="bd-autov">
        <img src="/pages/autovesti2/img/article1.jpg" alt="" class="bd-autov__img">
        <div class="bd-autov__category">Новинки</div>
        <div class="bd-autov__title">LAMBORGHINI HURACAN EVO ЭВОЛЮЦИОНИРОВАЛ В РОДСТЕР</div>
        <div class="bd-autov__p bd-autov__p_b">Компания Lamborghini
          продолжает обновление семейства Huracan: вторым в очереди на
          рестайлинг стала открытая версия Spyder. За возможность
          прокатиться без крыши со скоростью 325 км/ч придется заплатить
          сотни тысяч евро.</div>
        <div class="bd-autov__p">Главным отличием Spyder от купе
          стал мягкий верх с электрогидравлическим приводом. Опустить или
          поднять крышу он позволяет за 17 секунд, а сделать
          это можно на скорости до 50 км/ч. За акустический и воздушный комфорт
          в салоне отвечают два дополнительных обтекателя.</div>
        <img src="/pages/autovesti2/img/article2.jpg" alt="" class="bd-autov__img">
        <div class="bd-autov__p">Как и купе, спайдер Lamborghini
          Huracan Evo оснащается модернизированным V10 объемом 5,2 л.
          Развивает он в обоих случаях 640 л.с. и 600 Нм крутящего
          момента, но если купе способно набрать 100 км/ч за 2,9 с, а 200
          км/ч – за 9 секунд, то спайдеру потребуется 3,1 с и
          9,3 с соответственно. Объясняется это увеличившимся за счет
          превращения в кабриолет весом: открытая версия потяжелела на 120 кг.</div>

        <div class="bd-autov__buzz">
           <buzzCode @ready="ready" :id="id"></buzzCode>
        </div>

        <div class="bd-autov__p">Мотор на новом спайдере работает
          вместе с семиступенчатым роботом, системой полного привода и
          самоблокирующимся дифференциалом. Помогают ему полноуправляемое
          шасси и особая адаптивная система управления бортовой
          электроникой. Кроме того, для спайдера сделали более
          комфортабельным "шоссейный" режим ее работы (еще есть спортивный и
          трековый).</div>
        <img src="/pages/autovesti2/img/article3.jpg" alt="" class="bd-autov__img">
        <div class="bd-autov__p">Как и в случае с купе, спайдер можно
          будет опознать по доработанной передней части с новым
          сплиттером, новому заднему диффузору с двумя оконечниками
          выхлопной системы вместо четырех, а также новой центральной
          консоли в салоне с большим сенсорным экраном.</div>

        <div class="bd-autov__footer">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'autovesti2',
  data() {
    return {
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  computed: {
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    &_autovesti2
      background-color #FFF
      & ^[1]__menu
        fill #999
      .bd-ht__logo
        width 50%
        height auto
        margin auto
        fill #ff0147
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-autov
    font-family "Open Sans", sans-serif
    text-align left
    &__img
      display block
      width calc(100% - 48px)
      height auto
      margin 20px 24px
    &__date
      padding 40px 0 20px 24px
      fontSize(10,10)
      color #ff0147
    &__category
      display inline-block
      margin-left 24px
      padding 10px 18px
      background-color #ff0147
      fontSize(10,10)
      font-weight 600
      text-transform uppercase
      color white
    &__title
      margin 0 24px
      padding 20px 0
      fontSize(18,27)
      font-weight 100
      text-transform uppercase
      color #000
      &_small-indent
        padding 20px 0
        fontSize(25,30)
        text-transform none
    &__p
      margin 0 24px
      padding-bottom 20px
      fontSize(18,24)
      color #565656
      &_b
        font-weight 600
    &__buzz
      margin 0 0 24px
    &__news
      &-el
        padding-bottom 20px
    &__footer
      padding 24px 24px 30px
      background-color #252525
      &-logo
        width 40%
        margin 0 auto 40px
        padding 10px 30% 30px
        border-bottom 1px solid #444
        fill #FFF
      &-text
        fontSize(16,24)
        color #555

</style>
